import React, { useContext } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { UIContext } from "../shared/layout"
import Slider from "react-slick"
import FadedTitle from "../shared/faded-title"
import Grid from "../shared/grid"

import {
  SectionContainer,
  TitleContainer,
  CardsFlexContainer,
  CardsSliderContainer,
  TestimonialCardWrapper,
  TestimonialContentWrapper,
  TestimonialImage,
  TestimonialName,
  TestimonialTitle,
  TestimonialText,
} from "./employee-testimonials.style"

const TestimonialCardContainer = ({ children }) => {
  const {
    state: { breakpoint, clientLoaded },
  } = useContext(UIContext)
  return breakpoint === "sm" && clientLoaded ? (
    <CardsSliderContainer>
      <Slider dots arrows>
        {children}
      </Slider>
    </CardsSliderContainer>
  ) : (
    <CardsFlexContainer>{children}</CardsFlexContainer>
  )
}

const TestimonialCard = ({ fluidImg, name, title, description }) => {
  return (
    <TestimonialCardWrapper>
      <TestimonialImage fluid={fluidImg} alt={`A close-up photo of ${name}`} />
      <TestimonialContentWrapper>
        <TestimonialName>{name}</TestimonialName>
        <TestimonialTitle>{title}</TestimonialTitle>
        <TestimonialText>{description}</TestimonialText>
      </TestimonialContentWrapper>
    </TestimonialCardWrapper>
  )
}

export default function EmployeeTestimonials() {
  const query = useStaticQuery(graphql`
    query {
      fadeTitle: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/careers_faded_title.svg"
        }
      ) {
        publicURL
      }
      ulkarImg: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Employee Testimonials/ulkar.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 300, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      shaneImg: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Employee Testimonials/shane.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 300, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      nayeliImg: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Employee Testimonials/nayeli.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 300, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <SectionContainer>
      <Grid>
        <TitleContainer>
          <FadedTitle
            title="What Our Employees Are Saying"
            image={query.fadeTitle.publicURL}
            alt="Careers"
            fadeSettings={{ lg: "center" }}
            textAlign={"center"}
          />
        </TitleContainer>
        <TestimonialCardContainer>
          <TestimonialCard
            fluidImg={query.ulkarImg.childImageSharp.fluid}
            name="Ulkar"
            title="Software Development Manager"
            description="“I joined Mappedin because the moment I walked through the door, I felt what a great work environment it was. Plus I get to work with amazing people who are dedicated, smart and incredibly nice!”"
          />
          <TestimonialCard
            fluidImg={query.shaneImg.childImageSharp.fluid}
            name="Shane"
            title="Account Executive"
            description="“The Mappedin team really instilled confidence that this company was headed in a great direction and truly had a valuable product with enormous growth potential.”"
          />
          <TestimonialCard
            fluidImg={query.nayeliImg.childImageSharp.fluid}
            name="Nayeli"
            title="Customer Delivery Manager"
            description="“One of the best parts about working at Mappedin is being able to interact with so many people with different backgrounds and interests.”"
          />
        </TestimonialCardContainer>
      </Grid>
    </SectionContainer>
  )
}
